export const crossLace = (ctx: CanvasRenderingContext2D, color: string, x: number, y: number, numerator?: number, scaleSize?: number): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = color
  if (numerator !== undefined && numerator !== 0) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
    if (scaleSize !== undefined) {
      ctx.scale(scaleSize, scaleSize)
    }
  }
  // 左側
  ctx.beginPath()
  ctx.moveTo(635 + x, 149 + y) // 左上
  ctx.quadraticCurveTo(643 + x, 171 + y, 640 + x, 184 + y) // 左下
  ctx.quadraticCurveTo(642 + x, 188 + y, 646 + x, 185 + y) // 右下下
  ctx.quadraticCurveTo(654 + x, 168 + y, 641 + x, 148 + y) // 右上
  ctx.quadraticCurveTo(637 + x, 142 + y, 635 + x, 149 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(635 + x, 149 + y) // 下
  ctx.quadraticCurveTo(649 + x, 167 + y, 640 + x, 183 + y) // 上
  ctx.stroke()
  ctx.closePath()

  // 右側
  ctx.beginPath()
  // ctx.strokeStyle = 'blue' // '#383838'
  ctx.moveTo(627 + x, 164 + y) // 左上
  ctx.quadraticCurveTo(625 + x, 173 + y, 630 + x, 173 + y) // 左下
  ctx.quadraticCurveTo(645 + x, 168 + y, 657 + x, 175 + y) // 右下
  ctx.quadraticCurveTo(662 + x, 170 + y, 657 + x, 166 + y) // 右上
  ctx.quadraticCurveTo(648 + x, 158 + y, 627 + x, 164 + y) // 左上
  ctx.fill()
  // 断面ライン
  ctx.moveTo(627 + x, 173 + y) // 下
  ctx.quadraticCurveTo(646 + x, 164 + y, 658 + x, 174 + y) // 上
  ctx.stroke()
  ctx.closePath()

  if (numerator !== undefined) {
    ctx.restore()
  }
}
